import type { LinkedChild, Role } from '../hooks/use-roles';

/*
 * Où mène « Nouvelle conversation », selon le mode ACTIF de l'utilisateur.
 *
 * Le rôle actif est une lentille : un enseignant qui est aussi parent tient les
 * deux, et seul `activeRole` dit lequel il regarde. Router sur le premier rôle
 * trouvé enverrait ce compte-là au mauvais chat.
 *
 * `null` = aucune surface dédiée pour ce mode (admin / direction, ou rôles pas
 * encore chargés) : l'appelant retombe sur la création d'un fil générique.
 */
export interface NewConversationContext {
  readonly activeRole: Role | null;
  readonly children: readonly LinkedChild[];
  readonly activeStudentId: string | null;
}

export function newConversationRoute(ctx: NewConversationContext): string | null {
  if (ctx.activeRole === 'teacher') return '/teacher/chat';

  if (ctx.activeRole === 'tutor') {
    const child = ctx.children.find((c) => c.classroomStudentId === ctx.activeStudentId);
    /* Le chat s'active enfant par enfant : y envoyer un enfant sans activation
       mènerait à une page verrouillée — même garde que l'entrée de rail. */
    return child?.studentChatEnabled ? `/tutor/enfant/${child.classroomStudentId}/chat` : null;
  }

  return null;
}
